import { useDispatch, useSelector } from "react-redux";
import { toggleSideNav } from "../Store/reducers/Common";
import { NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import useWindowDimensions, { calHeightForMainSec } from "../Services/windowResize";

const SidebarSubmenu = ({
  title,
  iconClass,
  isParentActive,
  isOpen,
  setIsOpen,
  sideBarOpen,
  items
}) => {
  return (
    <li className={`${isParentActive ? "active" : ""}`}>
      <a
        href="#"
        title={title}
        className={`menu-link ${isParentActive ? "active" : ""}`}
        onClick={(e) => {
          e.preventDefault();
          setIsOpen((prev) => !prev);
        }}
      >
        <i className={iconClass}></i> {title}
        {sideBarOpen && (
          <i
            className={`fa-solid ${isOpen ? "fa-angle-down" : "fa-angle-right"}`}
            style={{ marginLeft: "auto", width: "auto", fontSize: "16px" }}
          ></i>
        )}
      </a>
      {
        sideBarOpen && (
          <ul className="sub-menus" style={{ display: isOpen ? "block" : "none" }}>
            {
              items.map((item) => (
                <li
                  key={item.to}
                  className={`${window.location.pathname.includes(item.to) ? "active" : ""}`}
                >
                  <NavLink to={item.to} title={item.title}>
                    {item.label}
                  </NavLink>
                </li>
              ))
            }
          </ul>
        )
      }
    </li>
  );
};

export default function SideNavbar() {
  const { userData } = useSelector((state) => state.user);
  const { sideBarOpen } = useSelector((state) => state.common);
  const { width, height } = useWindowDimensions();
  const dispatch = useDispatch();
  const location = useLocation();
  const [oldPath, setOldPath] = useState(location.pathname);
  const isMasterRoute = location.pathname.startsWith("/master");
  const isReportsRoute = location.pathname.startsWith("/reports");
  const [isMasterMenuOpen, setIsMasterMenuOpen] = useState(isMasterRoute);
  const [isReportsMenuOpen, setIsReportsMenuOpen] = useState(isReportsRoute);
  useEffect(() => {
    if (location.pathname !== oldPath && window.screen.width < 801) {
      setOldPath(location.pathname);
      if (sideBarOpen === true) {
        dispatch(toggleSideNav());
      }
    }
    if (location.pathname !== oldPath) {
      calHeightForMainSec(height);
    }
  }, [location.pathname, oldPath,dispatch])

  useEffect(() => {
    calHeightForMainSec(height);
    if (width < 787) {
      if (sideBarOpen === true) {
        dispatch(toggleSideNav());
      }
    }
  }, [width, height,dispatch])

  useEffect(() => {
    if (isMasterRoute) {
      setIsMasterMenuOpen(true);
    }
  }, [isMasterRoute]);

  useEffect(() => {
    if (isReportsRoute) {
      setIsReportsMenuOpen(true);
    }
  }, [isReportsRoute]);
  return (
    <div className={`left-navigation ${(sideBarOpen === true) ? "active" : ""}`}>
      {/* <button type="button" onClick={() => { dispatch(toggleSideNav()) }} className={`menu-icon ${(sideBarOpen === false) ? "close-icon" : ""}`}>
        <i className="fa-solid fa-xmark"></i>
      </button> */}
      <div
        className={`hamburger-box ${(sideBarOpen === true) ? "close-icon" : ""}`}
        onClick={() => {
          dispatch(toggleSideNav());
        }}
      >
        <div className="bun top"></div>
        <div className="meat"></div>
        <div className="bun bottom"></div>
      </div>
      <div className="user-profile-sidebar right-user-sec">
        <div className="user-details-sidebar">
          <span className="name-sec">{userData?.user_title_prefix} {userData?.first_name} {userData?.user_last_name}</span><br />
          {
            (userData.role_slug === "super_admin") ? "Super Admin"
              : (userData.role_slug === "org_admin") ? 'Organization Admin' :
                (userData?.user_intl_post) ? userData?.user_intl_post : (userData?.user_local_post) ? userData?.user_local_post :
                  userData.role_slug !== "member" ? userData.role_name : 'Member'
          }
        </div>
      </div>
      <ul>
        <li className={`${window.location.pathname === "/" ? "active" : ""}`}>
          <NavLink to="/" title="Dashboard">
            <i className="fa-solid fa-server"></i> Dashboard
          </NavLink>
        </li>
        {
          (userData.role_slug === "super_admin" || userData.role_slug === "org_admin" || userData.role_slug === "captain" || userData.role_slug === "div_admin" || userData.caps_list.includes('users_list')) &&
          <li className={`${window.location.pathname === "/members" ? "active" : ""}`}>
            <NavLink to="/members" title="members">
              <i className="fa-solid fa-users-line"></i> Members
            </NavLink>
          </li>
        }
        <li className={`${window.location.pathname === "/events" ? "active" : ""}`}>
          <NavLink to="/events" title="events">
            <i className="fa-solid fa-calendar-day"></i> Events
          </NavLink>
        </li>
        {
          (userData.role_slug === "super_admin" || userData.role_slug === "org_admin" || userData.role_slug === "div_admin" || userData.role_slug === "captain") &&
          <li className={`${window.location.pathname === "/division-transfer" ? "active" : ""}`}>
            <NavLink to="/division-transfer" title="Division Transfer">
              <i className="fa-solid fa-right-left"></i> Division Transfer
            </NavLink>
          </li>
        }
        <li className={`${window.location.pathname === "/payments" ? "active" : ""}`}>
          <NavLink to="/payments" title="Payments">
            <i className="fa-solid fa-receipt"></i> Payments
          </NavLink>
        </li>
        <li className={`${window.location.pathname.includes("/survey") ? "active" : ""}`}>
          <NavLink to="/survey" title="Survey">
            <i className="fa-solid fa-square-poll-vertical"></i> Survey
          </NavLink>
        </li>
        {/* {
          (userData.role_slug === "super_admin"
            || userData.caps_list.includes("manage_collections")
            || userData.caps_list.includes("view_collections")
            || userData.caps_list.includes("add_collection")
            || userData.caps_list.includes("edit_collection")
            || userData.caps_list.includes("submit_collection_payment")) &&
          <li className={`${window.location.pathname.includes("/collections") ? "active" : ""}`}>
            <NavLink to="/collections" title="Collections">
              <i className="fa-solid fa-hand-holding-dollar"></i> Collections
            </NavLink>
          </li>
        } */}
        <li className={`${window.location.pathname.includes("/takhmeen") ? "active" : ""}`}>
          <NavLink to="/takhmeen" title="Takhmeen">
            <i className="fa-solid fa-hand-holding-dollar"></i> Takhmeen
          </NavLink>
        </li>
        <li className={`${window.location.pathname === "/profile" ? "active" : ""}`}>
          <NavLink to="/profile" title="Porfile">
            <i className="fa-solid fa-id-card"></i> Profile
          </NavLink>
        </li>
        {
          (userData.role_slug === "super_admin" || userData.role_slug === "org_admin"|| userData.role_slug === "captain" || userData.role_slug === "div_admin" || userData.caps_list.includes('view_reports')) && <>
            <SidebarSubmenu
              title="Reports"
              iconClass="fa-solid fa-chart-line"
              isParentActive={isReportsRoute}
              isOpen={isReportsMenuOpen}
              setIsOpen={setIsReportsMenuOpen}
              sideBarOpen={sideBarOpen}
              items={[
                {
                  to: "/reports/members-attandance-report",
                  title: "Members Attendance",
                  label: "Members Attendance"
                }
              ]}
            />
          </>
          //   
        }
        {
          (userData.role_slug === "super_admin" || userData.role_slug === "org_admin" || userData.role_slug === "captain") && <>
            <li className={`${window.location.pathname === "/assign-roles" ? "active" : ""}`}>
              <NavLink to="/assign-roles" title="Assign Roles">
                <i className="fa-solid fa-users-viewfinder"></i> Assign Roles
              </NavLink>
            </li>
          </>
        }
        {
          userData.role_slug === "super_admin" &&
          <>
            <SidebarSubmenu
              title="Master"
              iconClass="fa-solid fa-gears"
              isParentActive={isMasterRoute}
              isOpen={isMasterMenuOpen}
              setIsOpen={setIsMasterMenuOpen}
              sideBarOpen={sideBarOpen}
              items={[
                {
                  to: "/master/organization-master",
                  title: "Organization Master",
                  label: "Organization Master"
                },
                {
                  to: "/master/division-master",
                  title: "Division Master",
                  label: "Division Master"
                },
                {
                  to: "/master/sector-master",
                  title: "Sector Master",
                  label: "Sector Master"
                }
              ]}
            />
            <li className={`${window.location.pathname.includes("/whatsapp") ? "active" : ""}`}>
              <NavLink to="/whatsapp" title="Whatsapp">
                <i className="fa-solid fa-republican"></i> Whatsapp
              </NavLink>
            </li>
          </>
        }
      </ul>
    </div>
  );
}
